import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserService } from "../../services/UserService";
import RolePermissions from "./RolePermissions";
import UserPermissions from "./UserPermissions";
import { useGeneralContext } from "../General/Context";
import UserPermission from "../../layout/left_menu_icons/user_permission.svg";

export default function PermissionPage() {
  const { t } = useTranslation();
  const [roles, setRoles] = useState([]);
  const { userInformation } = useGeneralContext();
  
  useEffect(() => UserService.getRoles().then((data) => setRoles(data)), []);
  return (
    <>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={UserPermission} alt="ni-icon" />
            <h1>{t("Permissions")}</h1>
          </div>
          <div className="subtitle">{t("Settings / Permissions")}</div>
        </div>
      </header>
      <ul className="nav nav-tabs" id="permissions" role="tablist">
        <li className="nav-item" role="presenttation">
          <button
            className="nav-link active"
            id="users-tab"
            data-bs-toggle="tab"
            data-bs-target="#users"
          >
            {t("Users")}
          </button>
        </li>
        <li className="nav-item">
          <button
            className="nav-link "
            id="roles-tab"
            data-bs-toggle="tab"
            data-bs-target="#roles"
          >
            {t("Roles")}
          </button>
        </li>
      </ul>
      <div class="tab-content" id="nav-tabContent">
        <div
          class="tab-pane fade show active"
          id="users"
          aria-labelledby="users-tab"
          aria-selected="true"
        >
          <UserPermissions roles={roles} />
        </div>
        <div
          class="tab-pane fade"
          id="roles"
          aria-labelledby="roles-tab"
          aria-selected="false"
        >
          <RolePermissions roles={roles} />
        </div>
      </div>
    </>
  );
}
